import { ArrowDownTrayIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import { toast } from "react-toastify";
import Button, { EButtonVariant } from "components/elements/Button";
import type { ExportFormat } from "./download";
import { exportSimulation } from "./download";
import type { SimulationExportInput } from "./report";
import classes from "../classes.module.scss";

const formats: [ExportFormat, string][] = [
	["xlsx", "Excel"],
	["docx", "Word"],
];

/** Exporte le résultat affiché : désactivé pendant un recalcul pour ne jamais exporter des chiffres périmés. */
export default function ExportButtons({ input, disabled }: { input: SimulationExportInput; disabled: boolean }) {
	const [pending, setPending] = useState<ExportFormat | null>(null);
	const run = async (format: ExportFormat) => {
		setPending(format);
		try {
			await exportSimulation(format, input);
		} catch (error) {
			console.error(error);
			toast.error("L’export n’a pas pu être généré. Réessayez.");
		} finally {
			setPending(null);
		}
	};
	return (
		<div className={classes["exports"]} role="group" aria-label="Exporter la simulation">
			<span aria-hidden="true">Exporter</span>
			{formats.map(([format, label]) => (
				<Button
					key={format}
					variant={EButtonVariant.OUTLINED}
					icon={<ArrowDownTrayIcon />}
					aria-label={`Exporter la simulation en ${label}`}
					loading={pending === format}
					disabled={disabled || pending !== null}
					onClick={() => void run(format)}>
					{label}
				</Button>
			))}
		</div>
	);
}
